<form [ngClass]="isInSection?'search-section':'search-block'" [formGroup]="searchForm">
  <div class="categories"
       id="dropdownSearch"
       data-bs-toggle="dropdown"
       aria-expanded="false">
    <div class="selected-category">
        <span class="text">
          {{selectedCategory ? selectedCategory.name : ('general.all' | translate)}}
          </span>
      <img class="icon" src="/assets/vectors/arrow_down.svg" alt="">
    </div>
  </div>
  <div class="dropdown-menu" aria-labelledby="dropdownSearch">
    <div (click)="selectCategory(null)"
         class="category-item">
      {{'general.all' | translate}}
    </div>
    <div *ngFor="let cat of categoryList"
         (click)="selectCategory(cat)"
         class="category-item">
      {{cat.name | translate}}
    </div>
  </div>

  <div class="search-item">
    <div class="inner_text">
      <label for="business">
        {{'general.book_service' | translate}}
      </label>
      <input
        type="text"
        name="business"
        id="business"
        formControlName="name"
        placeholder="{{'general.search_by_business' | translate}}"
      >
      <img src="/assets/vectors/search.svg" alt="">
    </div>
  </div>

  <div class="location search-item">
    <div class="inner_text">
      <label for="location">
        {{'general.search_by_location' | translate}}
      </label>
      <input type="text"
             name="business" id="location"
             formControlName="country"
             placeholder="{{'general.choose_location' | translate}}">
      <img src="/assets/vectors/fmd_good.svg" alt="">
    </div>
  </div>

  <div class="date-time search-item">
    <div class="inner_text">
      <label for="date">
        {{'general.date_and_time' | translate}}
      </label>
      <input [owlDateTime]="dt1"
             [owlDateTimeTrigger]="dt1"
             formControlName="appointmentDate"
             class="form-control" id="date"
             placeholder="{{'general.choose_date_and_time' | translate}}"
      >
      <img src="/assets/vectors/event.svg" alt="">

      <owl-date-time
        #dt1
        [pickerType]="'calendar'"
        [pickerMode]="'popup'"
        [panelClass]="'nopos'"
      ></owl-date-time>
    </div>
  </div>

  <div class="search search-item">
    <button class="btn btn-primary" (click)="searchBusiness()">
      <img src="/assets/vectors/search-white.svg">
      {{'general.search' | translate}}
    </button>
  </div>

</form>
